<template>
    <rkm-overlay>
        <rkm-layout-body title='Reagendamento e cancelamento de exames'>
            <template v-slot:actions>
                <rkm-button
                    @click.stop="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>
            </template>

            <rkm-layout-content>
                <Form
                    ref="Form"
                    :id="id"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/exame-imagem/reagendamento-cancelamento-exame/Form'

// Mixins.
import {unmask} from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: {
        Form,
    },
    created() {

        this.setShowExitFormConfirmation()
    },
    data: () => ({
        form: null,
    }),
    methods: {
        ...mapActions(['setShowExitFormConfirmation', 'unsetShowExitFormConfirmation']),
        handleExit() {

            this.showExitConfirmation(async () => {

                this.unsetShowExitFormConfirmation()
                this.redirectToList();
            })
        },
        redirectToList() {

            this.$router.push({ name: 'exame-imagem-reagendamento-cancelamento-exame-index' })
        },
    },
    mixins: [unmask],
    props: {
        id: { type: Number, default: null }
    },
}
</script>